import * as _ from 'lodash';
import * as React from 'react';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { LazyTabPane } from '../../components/LazyTabPane';
import { SurveyReviewGrid } from './lib/SurveyReviewGrid';

interface ISurveyReviewContainerState {
  activeTab: string
}

export class SurveyReviewContainer extends React.Component<{}, ISurveyReviewContainerState> {
  tabs = {
    NewSurveys: 'New Surveys',
    PublishReady: 'Surveys To Publish',
    CompletedSurveys: 'Completed Surveys',
    DeletedSurveys: 'Deleted Surveys',
  }

  state: ISurveyReviewContainerState = {
    activeTab: this.tabs.NewSurveys,
  }

  contentElement: HTMLElement

  setActiveTab(activeTab: string) {
    if (this.contentElement) {
      this.contentElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
    }

    this.setState({ activeTab })
  }

  render() {
    const { activeTab } = this.state;

    return (
      <section className="blacklight page-container">
        <section className="containerv2" ref={(contentElement) => this.contentElement = contentElement}>
          <Row>
            <Col md={4} lg={3} xl={2}>
              <Nav pills className="flex-column sticky-top-md-1 mb-4">
                {_.values(this.tabs).map((tab) =>
                  <NavItem key={tab}>
                    <NavLink
                      href="javascript:void(0)"
                      active={activeTab === tab}
                      onClick={() => this.setActiveTab(tab)}>
                      <h5 className="mb-0">{tab}</h5>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Col>
            <Col md={8} lg={9} xl={10}>
              <LazyTabPane activeTab={activeTab} tabId={this.tabs.NewSurveys} className="subtleSlideInRight">
                <SurveyReviewGrid newSurveys={true} completedMessage={'You have finished all surveys!'} />
              </LazyTabPane>
              <LazyTabPane activeTab={activeTab} tabId={this.tabs.PublishReady} className="subtleSlideInRight">
                <SurveyReviewGrid readyPublish={true} completedMessage={'You have finished all surveys!'} />
              </LazyTabPane>
              <LazyTabPane activeTab={activeTab} tabId={this.tabs.CompletedSurveys} className="subtleSlideInRight">
                <SurveyReviewGrid completedSurveys={true} completedMessage={'There are no completed surveys.'} />
              </LazyTabPane>
              <LazyTabPane activeTab={activeTab} tabId={this.tabs.DeletedSurveys} className="subtleSlideInRight">
                <SurveyReviewGrid deletedSurveys={true} completedMessage={'There are no deleted surveys.'} />
              </LazyTabPane>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}
